'use client';

import Link from 'next/link';
import { ForwardedRef, forwardRef, MutableRefObject } from 'react';
import { ButtonProps } from '@/app/types/components/ButtonProps';

const Button = forwardRef(
  (
    props: ButtonProps,
    ref?: ForwardedRef<HTMLButtonElement | HTMLAnchorElement | undefined>,
  ) => {
    const {
      type = 'button',
      children,
      onClick,
      className = '',
      disabled = false,
    } = props;
    if (type === 'link') {
      const { href = '/' } = props;
      return disabled ? (
        <div className={className}>{children}</div>
      ) : (
        <Link
          ref={ref as MutableRefObject<HTMLAnchorElement>}
          href={href}
          className={className}
        >
          {children}
        </Link>
      );
    }
    return (
      <button
        ref={ref as MutableRefObject<HTMLButtonElement>}
        className={className}
        onClick={(e) => {
          e.stopPropagation();
          onClick?.();
        }}
        type={type === 'button' ? 'button' : 'submit'}
        disabled={disabled}
      >
        {children}
      </button>
    );
  },
);

Button.displayName = 'Button';

export default Button;
